import { connect } from "react-redux";
import {
  clearBulkAnalyseCreateError,
  createBulkAnalyseRequest,
  getBulkAnalyseActiveRequest,
  getBulkAnalyseDetailRequest,
  getBulkAnalysePreviewRequest,
  dismissBulkAnalyseRequest,
  retryBulkAnalyseRequest,
  setBulkAnalyseJobOpen,
  startBulkAnalysePoll,
  stopBulkAnalysePoll,
  stopBulkAnalyseRequest,
} from "store/actions/bulkAnalyse.actions";
import {
  getBulkAnalyseCreateError,
  getBulkAnalyseCreateLoading,
  getBulkAnalyseFinishedVersion,
  getBulkAnalyseItems,
  getBulkAnalyseItemsLoading,
  getBulkAnalyseItemsPagination,
  getBulkAnalyseItemsStatus,
  getBulkAnalyseJob,
  getBulkAnalyseJobOpen,
  getBulkAnalysePreview,
  getBulkAnalysePreviewError,
  getBulkAnalysePreviewLoading,
  getBulkAnalyseRetryLoading,
  getBulkAnalyseDismissLoading,
  getBulkAnalyseStopError,
  getBulkAnalyseStopLoading,
} from "store/selector/bulkAnalyse.selector";
import { BulkAnalyseView } from "./BulkAnalyseContext";

const mapStateToProps = (state) => ({
  job: getBulkAnalyseJob(state),
  preview: getBulkAnalysePreview(state),
  previewLoading: getBulkAnalysePreviewLoading(state),
  previewError: getBulkAnalysePreviewError(state),
  createLoading: getBulkAnalyseCreateLoading(state),
  createError: getBulkAnalyseCreateError(state),
  stopLoading: getBulkAnalyseStopLoading(state),
  stopError: getBulkAnalyseStopError(state),
  retryLoading: getBulkAnalyseRetryLoading(state),
  dismissLoading: getBulkAnalyseDismissLoading(state),
  items: getBulkAnalyseItems(state),
  itemsPagination: getBulkAnalyseItemsPagination(state),
  itemsStatus: getBulkAnalyseItemsStatus(state),
  itemsLoading: getBulkAnalyseItemsLoading(state),
  jobOpen: getBulkAnalyseJobOpen(state),
  finishedVersion: getBulkAnalyseFinishedVersion(state),
});

const mapDispatchToProps = {
  loadActive: getBulkAnalyseActiveRequest,
  loadPreview: getBulkAnalysePreviewRequest,
  startRun: createBulkAnalyseRequest,
  loadDetail: getBulkAnalyseDetailRequest,
  stopRun: stopBulkAnalyseRequest,
  retryRun: retryBulkAnalyseRequest,
  dismissBanner: dismissBulkAnalyseRequest,
  setJobOpen: setBulkAnalyseJobOpen,
  startPoll: startBulkAnalysePoll,
  stopPoll: stopBulkAnalysePoll,
  clearCreateError: clearBulkAnalyseCreateError,
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkAnalyseView);
